import React from "react"
import PanelLayoutContent from "components/layout/PanelLayoutContent"
import { useCustomQuery } from "hooks/useCustomQuery"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { ProfileOfferService } from "services/api-service"
import { OfferType } from "services/api-service/types"
import { RootState } from "store/store"
import { Row } from "ui/components/atoms/_atoms"
import { IconButton } from "ui/components/atoms/button"
import { H2 } from "ui/components/atoms/typography"

const OfferInfo = () => {
  const { t } = useTranslation(["panel", "common"])
  const navigate = useNavigate()
  const { offerId = "" } = useParams()

  const { profile } = useSelector((state: RootState) => state.profile)

  const { isLoading, data } = useCustomQuery<OfferType>({ key: ["offer", offerId] }, () =>
    ProfileOfferService.getOffer(offerId),
  )

  return (
    <>
      <PanelLayoutContent title={t("offers.list.title")} text={t("offers.list.text")}>
        <Row $alignItems="center">
          <IconButton
            $background="background"
            $size="45px"
            $iconSize="L"
            $borderRadius="borderRadius"
            onClick={() => navigate(`/panel/offers`)}
            icon="arrow-left"
            $marginRight="S"
            ariaLabel="Go back"
          />
          <H2 $marginBottom="0">{data?.name}</H2>
        </Row>
        <Outlet />
      </PanelLayoutContent>
    </>
  )
}

export default OfferInfo
